{
  "version": 1,
  "asset_id": "ab46758b-a65e-4808-8783-4140e09d451e",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/ab46758b-a65e-4808-8783-4140e09d451e/hiatal-type-1-repair-es-800.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/ab46758b-a65e-4808-8783-4140e09d451e/hiatal-type-1-repair-es-800.webp",
  "original_filename": "hiatal-type-1-repair-es-800.webp",
  "size": 42186,
  "content_type": "image/webp",
  "created_at": "2026-10-04T15:54:54Z"
}
